export enum EpH {

    pH2 = 1 ,
    pH4 = 2,
    pH7005 = 3,
    pH7010 = 4,
    pH10 = 5,
    pH12 = 6,
}